import { useEffect, useState, useRef } from 'react';
import { Row, Col, ClassifyStructure, Form, message, Card, Transfer, Select, Modal, Input, jsonToQueryString, Button, MainModal, Typography, Tabs, Divider } from '../../../ui/ot';
import ScatterChart from "../../../charts/views/scatter_chart_component";
import BarChart from "../../../charts/views/bar_chart_component";
import LineChart from '../../../charts/views/line_chart_component';
import PortalCard from "../../components/portal_card";
import WordCloudChart from '../../../charts/views/word_cloud_chart';
import { useCRUDController } from '../../../ui/classify_structure/CRUDController';

const PortalMainPage = ({ prefixTitle }) => {

    //讀者借閱活躍統計
    const borrowersBorrowController = useCRUDController({
        apiRoute: '/koha/portal/borrowers_borrow'
    })
    //最常借閱排行
    const booksBorrowController = useCRUDController({
        apiRoute: '/koha/portal/books_borrow'
    })

    const changeBooksBorrowDatas = (datas, type) => {
        if (type === "讀者") {
            return (
                datas.map(data => (
                    {
                        type: data.讀者姓名,
                        value: data.借閱次數,
                        key: data.key
                    }
                ))
            )
        }
        else {
            return (
                datas.map(data => (
                    {
                        type: data.書本名稱,
                        value: data.借閱次數,
                        key: data.key
                    }
                ))
            )
        }
    }

    //期刊點收項目
    const serialitemsController = useCRUDController({
        apiRoute: '/koha/portal/serialitems'
    })


    const changeBarChartDatas = (datas) => {
        if (datas && datas.length !== 0) {
            return (
                datas.map(data => (
                    {
                        type: data.time_unit,
                        value: data.borrow_count,
                        key: data.key
                    }
                ))
            )
        }
        else {
            return [];
        }
    }

    const [trendOption, setTrendOption] = useState("Day");

    //借閱統計
    const dayborrowStatisticController = useCRUDController({
        apiRoute: '/koha/portal/borrow_statistic'
    })
    const weekBorrowStatisticController = useCRUDController({
        apiRoute: '/koha/portal/borrow_statistic'
    })
    const monthBorrowStatisticController = useCRUDController({
        apiRoute: '/koha/portal/borrow_statistic'
    })

    //館藏量
    const collectionSizeController = useCRUDController({
        apiRoute: '/koha/portal/collection_size'
    })

    //讀者數
    const numbersOfReaderController = useCRUDController({
        apiRoute: '/koha/portal/numbers_of_reader'
    })

    //一週內逾期人數
    const overdueInOneWeekController = useCRUDController({
        apiRoute: '/koha/portal/overdue_in_one_week'
    })

    // 根據選擇的時間範圍處理資料
    const borrowStatisticDatas = (option) => {
        if (option === "Day") {
            return changeBarChartDatas(dayborrowStatisticController.ResponseData); // 根據日來處理資料
        } else if (option === "Week") {
            return changeBarChartDatas(weekBorrowStatisticController.ResponseData); // 根據週來處理資料
        } else if (option === "Month") {
            return changeBarChartDatas(monthBorrowStatisticController.ResponseData); // 根據月來處理資料
        }
    };


    useEffect(() => {
        collectionSizeController.getData()
        numbersOfReaderController.getData()
        overdueInOneWeekController.getData()
        dayborrowStatisticController.getData()
        weekBorrowStatisticController.getData({
            time_unit: "Week"
        })
        monthBorrowStatisticController.getData({
            time_unit: "Month"
        })
        serialitemsController.getData()
        booksBorrowController.getData({
            issuedate_start: '',
            issuedate_end: '',
            order: [{ "type": "DESC", "column": "借閱次數" }],
        })
        borrowersBorrowController.getData({
            issuedate_start: '',
            issuedate_end: '',
            order: [{ "type": "DESC", "column": "借閱次數" }],
        })

    }, [])

    return (
        <Row
            gutter={[8, 8]}
        >
            <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
                <PortalCard
                    title="館藏量"
                    value={collectionSizeController.ResponseData.find(_ => true)?.biblios_count}
                    unit="本"
                    cardColor="#FFEDB5"
                    url="/library/backstage/BookDetail"></PortalCard>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
                <PortalCard
                    title="讀者數"
                    value={numbersOfReaderController.ResponseData.find(_ => true)?.borrowers_count}
                    unit="人"
                    cardColor="#FFE0A3"
                    url="/library/backstage/staff_patron"></PortalCard>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
                <PortalCard
                    title="一週內逾期"
                    value={overdueInOneWeekController.ResponseData.find(_ => true)?.due_soon_users}
                    unit="人"
                    cardColor="#FFD1A1"
                    url="/library/backstage/overdue_processing"></PortalCard>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <Row gutter={[16, 16]}>
                    <Col>
                        <Typography.Title level={4}>
                            借閱統計
                        </Typography.Title>
                    </Col>

                    <Col>
                        <Button type="link"
                            onClick={() => {
                                window.open("/library/backstage/Patrons/CheckOutHistory");
                            }}
                        >借閱紀錄</Button>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col span={12}>
                                <Tabs
                                    items={[
                                        {
                                            key: "Day",
                                            tab: "天"
                                        },
                                        {
                                            key: "Week",
                                            tab: "週"
                                        },
                                        {
                                            key: "Month",
                                            tab: "月"
                                        }
                                    ]}
                                    onChange={(option) => {
                                        setTrendOption(option)
                                    }}
                                />
                            </Col>
                            <Col span={24} style={{ height: window.innerHeight * 0.3 }}>
                                <BarChart
                                    datas={borrowStatisticDatas(trendOption)}
                                />

                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>

            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <Row gutter={[8, 8]}>
                    <Col>
                        <Typography.Title level={4}>
                            期刊點收
                        </Typography.Title>
                    </Col>
                    <Col>
                        <Button type="link"
                            onClick={() => {
                                window.open("/library/backstage/serial_orderlist_management");
                            }}
                        >查看更多</Button>
                    </Col>
                    <Col span={24}
                        style={{
                            height: window.innerHeight * 0.4,
                            overflowY: 'auto',  // 設置垂直溢出顯示滾動條
                            display: 'flex',
                            flexDirection: 'column', // 使用flex確保子元素正確排佈
                        }}>
                        <Row gutter={[8, 8]} style={{
                            display: 'flex',
                            alignItems: 'center',  // 垂直居中對齊
                            justifyContent: 'space-between', // 在水平方向上平均分配空間
                            // padding: '1rem'
                        }}>
                            {serialitemsController.ResponseData &&
                                serialitemsController.ResponseData.map((item, index) => {
                                    let backgroundColor;
                                    // 根據名次設置柔和的顏色
                                    if (index === 0) {
                                        backgroundColor = '#FFEDB5';  // 第一名 顯示為柔和的金黃色
                                    } else if (index === 1) {
                                        backgroundColor = '#FFE0A3';  // 第二名 顯示為柔和的橙色
                                    } else if (index === 2) {
                                        backgroundColor = '#FFD1A1';  // 第三名 顯示為柔和的橙紅色
                                    } else {
                                        backgroundColor = '#F4F8FB';  // 其他名次 使用柔和的淡藍色背景
                                    }

                                    return (
                                        <Col
                                            span={24}
                                            key={item.key}
                                            style={{
                                                backgroundColor: backgroundColor,
                                                border: '1px solid #ddd',
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                borderRadius: '0.5rem',
                                                padding: '0.5rem'
                                            }}
                                        >
                                            <Row
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                }}
                                            >
                                                <Col style={{ width: '100%' }}>
                                                    <span
                                                        style={{
                                                            display: '-webkit-box',
                                                            WebkitBoxOrient: 'vertical',
                                                            WebkitLineClamp: 2, // 這裡可調整最多顯示的行數
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'normal',
                                                            wordBreak: 'break-word',
                                                        }}
                                                    >
                                                        {item.期刊名稱}{item.副標題}
                                                    </span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    );
                                })
                            }
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <Row gutter={[16, 16]}>
                    <Col>
                        <Typography.Title level={4}>
                            最常借閱排行
                        </Typography.Title>
                    </Col>
                    <Col>
                        <Button type="link"
                            onClick={() => {
                                window.open("/library/backstage/Patrons/CheckOutHistory");
                            }}>借閱紀錄</Button>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col span={12}>

                            </Col>
                            <Col span={24} style={{ height: window.innerHeight * 0.3 }}>
                                {/* {console.log(changeBooksBorrowDatas(booksBorrowController.ResponseData))} */}
                                <BarChart
                                    datas={changeBooksBorrowDatas(booksBorrowController.ResponseData)}
                                />
                            </Col>
                        </Row>
                    </Col>


                </Row>

            </Col>
            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <Row gutter={[16, 16]}>
                    <Col>
                        <Typography.Title level={4}>
                            讀者借閱活躍統計
                        </Typography.Title>
                    </Col>
                    <Col>
                        <Button type="link"
                            onClick={() => {
                                window.open("/library/backstage/Patrons/CheckOutHistory");
                            }}>借閱紀錄</Button>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col span={12}>

                            </Col>
                            <Col span={24} style={{ height: window.innerHeight * 0.3 }}>
                                {/* {console.log(changeBooksBorrowDatas(booksBorrowController.ResponseData))} */}
                                <BarChart
                                    datas={changeBooksBorrowDatas(borrowersBorrowController.ResponseData, "讀者")}
                                />
                            </Col>
                        </Row>
                    </Col>


                </Row>

            </Col>
            {/* <Col span={24}>
                <Row gutter={[16, 16]}>
                    <Col lg={8} md={24} sm={24} xs={24}>
                        <Row span={[32, 32]}>
                            <Col span={24}>
                                <Typography.Title
                                    level={2}
                                >
                                    {prefixTitle}
                                </Typography.Title>
                            </Col>
                            <Divider />
                            <Col span={24}>
                                <Row gutter={[16, 16]}>
                                    <Col>
                                        <Typography.Title level={4}>
                                            多國語言翻譯統計
                                        </Typography.Title>
                                    </Col>
                                    <Col>
                                        <Button type="link">文件翻譯</Button>
                                    </Col>
                                    <Col span={24} style={{ height: window.innerHeight * 0.3 }}>

                                        <BarChart

                                        datas={multipleLanguageController.ResponseData}
                                        />

                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[16, 16]}>

                                    <Col>
                                        <Typography.Title
                                            level={4}
                                        >
                                            文件數量與類型分布
                                        </Typography.Title>
                                    </Col>
                                    <Col>
                                        <Button type="link">文件上傳</Button>
                                    </Col>

                                    <Col span={24}>
                                        <DonutProgress
                                            colorTheams="softHuesCollection"
                                            DonutData={
                                                changeDonutDatas(documentTypeController.ResponseData)
                                            }
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={16} md={24} sm={24} xs={24}>
                        <Row gutter={[16, 16]}>
                            <Col lg={12} md={24} sm={24} xs={24}>
                                <Row gutter={[8, 8]}>
                                    <Col span={24}>
                                        <Row justify={"space-between"}>
                                            <Col>
                                                <Typography.Title level={4}>
                                                    網站瀏覽人次趨勢
                                                </Typography.Title>
                                            </Col>
                                            <Col>
                                                <Button type="link">查看更多</Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Row gutter={[8, 8]}>
                                            <Col span={24}>
                                                <Tabs
                                                    items={[
                                                        {
                                                            key: "Day",
                                                            tab: "天"
                                                        },
                                                        {
                                                            key: "Week",
                                                            tab: "週"
                                                        },
                                                        {
                                                            key: "Month",
                                                            tab: "月"
                                                        }
                                                    ]}
                                                    onChange={(option) => {
                                                        setTrendOption(option)
                                                    }}
                                                />
                                            </Col>
                                            <Col span={24} style={{ height: window.innerHeight * 0.3 }}>
                                                <LineChart
                                                datas={lineChartDatas(trendOption)}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}>
                                <Row>
                                    <Col span={24}>
                                        <Row justify={"space-between"}>
                                            <Col>
                                                <Typography.Title level={4}>
                                                    網站停留時間統計
                                                </Typography.Title>
                                            </Col>
                                            <Col>
                                                <Button type="link">查看更多</Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} style={{ height: window.innerHeight * 0.4 }}>
                                        <ScatterChart
                                        datas={stayTimeController.ResponseData}

                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Divider />
                            </Col>
                            <Col span={24}>
                                <Row>
                                    <Col span={24}>
                                        <Row justify={"space-between"}>
                                            <Col>
                                                <Typography.Title level={4}>
                                                    熱門搜尋關鍵字
                                                </Typography.Title>
                                            </Col>
                                            <Col>
                                                <Button type="link">查看更多</Button>
                                            </Col>
                                        </Row>
                                    </Col>

                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col> */}
        </Row>
    );
};

export default PortalMainPage;
